<div class="app-layout-wrapper">
  <app-navigation
    *ngIf="showNavigation"
    (sidebarToggled)="onSidebarToggled($event)"
  >
  </app-navigation>

  <div
    class="main-content-wrapper"
    [class.sidebar-visible]="showNavigation && isSidebarExpanded"
    [class.sidebar-collapsed]="showNavigation && !isSidebarExpanded"
    [class.no-sidebar]="!showNavigation"
  >
    <div
      class="container main-container"
      [ngClass]="{
        'container-wide': useWideFormat,
        'no-shrink': noShrink,
        'full-width': !showNavigation,
      }"
    >
      <app-spinner></app-spinner>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<app-modal></app-modal>
